import React from 'react'
import { addNewPaymentMethod } from 'client/utils/api-routes-invoice'
import moment from 'moment'
import {
  DcButton,
  DcInput,
  PixelDropDown,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { Customer, PaymentMethod } from '../../../../../../../decl'
import { IPixelFactory } from '../../../../../../../decl.d'

const cardType = [
  {
    label: 'Select Card Type',
    value: '',
  },
  {
    label: 'Visa',
    value: 'Visa',
  },
  {
    label: 'Master',
    value: 'Master',
  },
  {
    label: 'Discover',
    value: 'Discover',
  },
  {
    label: 'AMEX',
    value: 'AMEX',
  },
]
const accountType = [
  {
    label: 'Select Account Type',
    value: '',
  },
  {
    label: 'Savings',
    value: 'savings',
  },
  {
    label: 'Checking',
    value: 'checking',
  },

  {
    label: 'Business',
    value: 'business',
  },
]
const months = [
  {
    label: 'Expiry Month',
    value: '',
  },
  {
    value: '01',
    label: 'January',
  },
  {
    value: '02',
    label: 'February',
  },
  {
    value: '03',
    label: 'March',
  },
  {
    value: '04',
    label: 'April',
  },
  {
    value: '05',
    label: 'May',
  },
  {
    value: '06',
    label: 'June',
  },
  {
    value: '07',
    label: 'July',
  },
  {
    value: '08',
    label: 'August',
  },
  {
    value: '09',
    label: 'September',
  },
  {
    value: '10',
    label: 'October',
  },
  {
    value: '11',
    label: 'November',
  },
  {
    value: '12',
    label: 'December',
  },
]
const getYear = () => {
  const year: any = [
    {
      label: 'Expiry Year',
      value: '',
    },
  ]
  for (let i = moment().year(); i < moment().year() + 10; i++) {
    year.push({
      value: i,
      label: i,
    })
  }
  return year
}
interface IProps {
  handleClose: () => void
  newPaymentMethod: PaymentMethod[]
  customerData: Customer
}
const AddNewPaymentMethod = (props: IProps) => {
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const { handleClose, newPaymentMethod, customerData } = props
  const options = newPaymentMethod.map((item) => {
    return { label: item?.name, value: item?.type }
  })

  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const [data, setData] = React.useState<any>({
    account_number: '',
    bank_name: '',
    customer_id: customerData?.customer_id,
    method_type: 'bank',
    name_on_account: '',
    routing_number: '',
    card_number: '',
    card_type: '',
    cvc: '',
    expiry_month: '',
    expiry_year: '',
    account_id: '',
    account_type: '',
  })
  const PaymentMethodTypes = (data) => {
    switch (data.method_type) {
      case 'card':
        return {
          card_number: data.card_number,
          card_type: data.card_type,
          customer_id: data.customer_id,
          cvc: data.cvc,
          expiry_date: `${data.expiry_month}/${data.expiry_year}`,
          method_type: 'card',
          name_on_account: data.name_on_account,
        }
      case 'bank':
        return {
          account_number: data.account_number,
          bank_name: data.bank_name,
          customer_id: data.customer_id,
          method_type: 'bank',
          name_on_account: data.name_on_account,
          routing_number: data.routing_number,
          account_type: data.account_type,
        }
      case 'venmo':
      case 'zelle':
      case 'Prepaids':
      case 'paypal':
      case 'cashapp':
        return {
          account_id: data.account_id,
          customer_id: data.customer_id,
          method_type: data.method_type,
          name_on_account: data.name_on_account,
        }
    }
    return {}
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    addNewPaymentMethod(
      customerData?.customer_id,
      PaymentMethodTypes(data),
    ).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Payment Method Added Successfully')
        handleClose(res.response.data)
      } else {
        if (res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }

      hidePageLoader()
    })
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <PixelDropDown
          error={
            error.field === 'method_type' && error.error !== ''
              ? error.error
              : null
          }
          value={data.method_type}
          options={options}
          placeholder={'Select Payment Method'}
          name={'method_type'}
          onChange={(e) => setData({ ...data, method_type: e.target.value })}
        />
      </FormGroup>
      {['card', 'bank'].includes(data.method_type) && (
        <>
          <FormGroup>
            <DcInput
              isMakingInput={data.method_type === 'card' && true}
              error={
                data.method_type === 'bank'
                  ? error.field === 'bank_name' && error.error !== ''
                    ? error.error
                    : null
                  : error.field === 'card_number' && error.error !== ''
                  ? error.error
                  : null
              }
              mask={'9999 9999 9999 9999'}
              maskChar={'-'}
              alwaysShowMask={false}
              required
              type={'text'}
              name={'bank_name'}
              placeholder={
                data.method_type === 'card' ? 'Card Number' : 'Bank Name'
              }
              value={
                data.method_type === 'card' ? data.card_number : data.bank_name
              }
              onChange={(e) => {
                if (data.method_type === 'card') {
                  setData({ ...data, card_number: e.target.value })
                } else {
                  setData({ ...data, bank_name: e.target.value })
                }
              }}
            />
          </FormGroup>
          <FormGroup>
            <PixelDropDown
              error={
                data.method_type === 'card'
                  ? error.field === 'card_type' && error.error !== ''
                    ? error.error
                    : null
                  : error.field === 'account_type' && error.error !== ''
                  ? error.error
                  : null
              }
              value={
                data.method_type === 'card' ? data.card_type : data.account_type
              }
              options={data.method_type === 'card' ? cardType : accountType}
              placeholder={'Select Account Type'}
              name={'method_type'}
              onChange={(e) => {
                if (data.method_type === 'card') {
                  setData({ ...data, card_type: e.target.value })
                } else {
                  setData({ ...data, account_type: e.target.value })
                }
              }}
            />
          </FormGroup>
        </>
      )}

      <FormGroup>
        <DcInput
          error={
            error.field === 'name_on_account' && error.error !== ''
              ? error.error
              : null
          }
          required
          type={'text'}
          name={'name_on_account'}
          placeholder={'Name on Account'}
          value={data.name_on_account}
          onChange={(e) =>
            setData({ ...data, name_on_account: e.target.value })
          }
        />
      </FormGroup>
      {data.method_type === 'card' && (
        // -------------------------- card expiry date --------------------------
        <>
          <FormGroup>
            <PixelDropDown
              error={
                error.field === 'expiry_date' && error.error !== ''
                  ? error.error
                  : null
              }
              value={data.expiry_month}
              options={months}
              placeholder={'Select Month'}
              name={'expiry_month'}
              onChange={(e) => {
                setData({ ...data, expiry_month: e.target.value })
              }}
            />
            <PixelDropDown
              error={
                error.field === 'expiry_date' && error.error !== ''
                  ? error.error
                  : null
              }
              value={data.expiry_year}
              options={getYear()}
              placeholder={'Select Year'}
              name={'expiry_year'}
              onChange={(e) => {
                setData({ ...data, expiry_year: e.target.value })
              }}
            />
          </FormGroup>
          <FormGroup>
            <DcInput
              error={
                error.field === 'cvc' && error.error !== '' ? error.error : null
              }
              required
              type={'text'}
              name={'cvc'}
              placeholder={'CVC'}
              value={data.cvc}
              onChange={(e) => setData({ ...data, cvc: e.target.value })}
            />
          </FormGroup>
        </>
      )}
      {data.method_type === 'bank' && (
        <>
          <FormGroup>
            <DcInput
              error={
                error.field === 'routing_number' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'routing_number'}
              placeholder={'Routing Number'}
              value={data.routing_number}
              onChange={(e) =>
                setData({ ...data, routing_number: e.target.value })
              }
            />
          </FormGroup>

          <FormGroup>
            <DcInput
              error={
                error.field === 'account_number' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'account_number'}
              placeholder={'Account Number'}
              value={data.account_number}
              onChange={(e) =>
                setData({ ...data, account_number: e.target.value })
              }
            />
          </FormGroup>
        </>
      )}
      {['zelle', 'venmo', 'paypal', 'cashapp'].includes(data.method_type) && (
        <>
          <DcInput
            error={
              error.field === 'account_id' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'text'}
            name={'account_id'}
            placeholder={'Account ID'}
            value={data.account_id}
            onChange={(e) => setData({ ...data, account_id: e.target.value })}
          />
        </>
      )}
      <FormGroup>
        <DcButton
          variant="outline-secondary"
          onClick={() => {
            handleClose()
          }}
        >
          Close
        </DcButton>
        <DcButton type={'submit'}>Save</DcButton>
      </FormGroup>
    </Form>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default AddNewPaymentMethod
